// extracted by mini-css-extract-plugin
module.exports = {"Curve":"styles_Curve__22QEa"};